import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toJS } from '../../../utils/immutableUtils';
import {
  getMarketSettings,
  getFetchError,
  getIsFetching
} from 'features/MarketSettingContainer/selector';
import { fetchMarketSettings } from 'features/MarketSettingContainer/actions';

const useMarketSettings = ({ forceFetch = false } = {}) => {
  const dispatch = useDispatch();

  const [isMounted, setIsMounted] = useState(false);
  const marketSettings = useSelector(getMarketSettings);
  const isFetchingPpsi = useSelector(getIsFetching);
  const fetchError = useSelector(getFetchError);
  const isFetching = !isMounted ? true : isFetchingPpsi;
  const isFetched = !!marketSettings;

  useEffect(() => {
    if (isMounted) {
      return;
    }
    if (!isFetched || forceFetch) {
      dispatch(fetchMarketSettings());
    }
    setIsMounted(true);
  }, [dispatch, forceFetch, isFetched, isMounted]);

  return [isFetching, isFetching ? null : toJS(marketSettings), fetchError];
};

export default useMarketSettings;
